export default "__VITE_ASSET__b90248ce__"